module.exports = __webpack_public_path__ + "static/Camargo_CV-4aca5bf00247423fb099a759e2168fa3.pdf";